module.exports = __webpack_public_path__ + "img/clip_img.5a9df2d9.png";